import { ProductListItemDTO } from '@iota/inh-core-v1-management-client';
import { createSmartTable } from '../../components/smart-table/smart-table.component';
import { filterProductsByText, PRODUCT_TABLE_HEADERS, productTableCells } from '../../services/product-list.mapper';

export function filterSelectableProducts(
    products: ProductListItemDTO[],
    filterText: string,
    alreadySelectedProductIds: string[]
): ProductListItemDTO[] {
    const selectable = products.filter((product) => !product.isDiscontinued && !alreadySelectedProductIds.includes(product.productId));

    return filterProductsByText(selectable, filterText);
}

export function toProductSelectionTable(products: ProductListItemDTO[], selectedProductIds: string[]) {
    return createSmartTable({
        headers: [{ key: 'selected', label: '' }, ...PRODUCT_TABLE_HEADERS, { key: 'productId', hidden: true }],
        rows: products.map((product) => ({
            selected: { data: '', rawData: selectedProductIds.includes(product.productId) },
            ...productTableCells(product),
            productId: { data: product.productId }
        }))
    });
}
